import { callFetch } from './serviceHelpers';

export const getChangeRequestsByItemId = itemId =>
  callFetch(process.env.REACT_APP_CHANGE_REQUEST_ROUTER_URL, 'GET', `v2/changeRequests?itemId=${itemId}`);
